import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleGoogleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const sessionMatch = hash.match(/session_id=([^&]+)/);
    if (!sessionMatch) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = sessionMatch[1];

    (async () => {
      const result = await handleGoogleSession(sessionId);
      if (result.ok) {
        toast.success(`Welcome, ${result.user.name}!`);
        // Clean the URL and go to dashboard
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } else {
        toast.error(result.error || "Google sign-in failed");
        navigate("/", { replace: true });
      }
    })();
  }, [handleGoogleSession, navigate, location.hash]);

  return (
    <div className="min-h-screen grid place-items-center" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3 text-navy-600">
        <Loader2 className="h-8 w-8 animate-spin text-saffron-600" />
        <div className="text-sm">Signing you in...</div>
      </div>
    </div>
  );
};

export default AuthCallback;
